import React, { createContext, useEffect, useState } from 'react';
import { auth } from '../firebaseconfig';
import { onAuthStateChanged } from 'firebase/auth';

export const AuthContext = createContext(null);

export function AuthProvider({ children }) {

    const [user, setUser] = useState(null)
    const [loading, setLoading] = useState(true)

    useEffect(() => {

        //Listen for auth state changes
        const unsubscribe = onAuthStateChanged(auth, async(user) => {
            setUser(user)
            setLoading(false)
        })

        return unsubscribe;
    }, []);

    //Sign out, remove email from local storage
    const signOut =() => {
        auth.signOut()
        .then(() => {
            window.localStorage.removeItem("emailForSignIn")
            setLoading(false)
        })
    }

    return (
        <AuthContext.Provider value={{ user, loading, signOut }}>
            {children}
        </AuthContext.Provider>
    );
}
